module.exports = __webpack_public_path__ + "static/media/bg3.e568fccc.png";